/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Enrich_StartInputs */

const en_directory_submit_enrich_start = /** @type {(inputs: Directory_Submit_Enrich_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start`)
};

const zh_directory_submit_enrich_start = /** @type {(inputs: Directory_Submit_Enrich_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始`)
};

/**
* | output |
* | --- |
* | "Start" |
*
* @param {Directory_Submit_Enrich_StartInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_enrich_start = /** @type {((inputs?: Directory_Submit_Enrich_StartInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Enrich_StartInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_enrich_start(inputs)
	return zh_directory_submit_enrich_start(inputs)
});
export { directory_submit_enrich_start as "directory.submit.enrich.start" }